<template>
  <section>
    <div class="container">
      <div class="head">
        <img src="@/assets/back.png" style="margin: 10px" alt="返回" width="21" height="21" @click="go">
        <div>我的余额</div>
        <div style="margin-right: 10px;color: #FE003B" @click="detail">明细</div>
      </div>
      <div class="content">
        <div class="rechargeimg" :style="rechargeimg"  style=" width: 100%;">
          <div class="rehint">账户余额（元）</div>
          <div class="reprice">{{getUserBalance}}</div>
        </div>
        <div class="choose">充值</div>
        <div class="recharge">
          <div class="item" v-for="(item,index) in moneyList" :key="index" @click="check(item)" :class="active===item.money?'active':''">
            <p>{{item.money}}元</p>
            <p style="color: #FE003B;font-size: 15px;">赠送{{item.give}}元</p>
          </div>
        </div>
        <div class="money">
          <van-field v-model="form.money" maxlength="11" style="width: 100%;text-align: center;" placeholder="请输入充值金额￥0.00" />
        </div>
      </div>
      <div class="retype">
        <div>充值方式</div>
        <img src="@/assets/wechat.png" style="height: 20px;width: 20px;margin-left: 10%"/>
        <span class="wechat">微信支付</span>
      </div>
      <div class="submit" @click="submit">立即充值</div>
    </div>

  </section>
</template>

<script>
import { queryShopUserList } from '../../api/mine/getUser.js'
import { wxPayBalance,queryBalance } from '../../api/mine/reCharge.js'
import {getShopChargeRulesList} from '@/api/chargeRules.js'
export default {
  name: 'MineRecharge',
  data() {
    return {
      rechargeimg: {
        backgroundImage: 'url(' + require('@/assets/recharge.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%',
        mozBackgroundSize: '100% 100%'
      },
      moneyList: [

      ],
      active: '0',
      form: {
        money: '',
        openid: localStorage.getItem('openid'),
        uid: ''
      }
    }
  },
  created() {
    // this.$store.dispatch('GetUserInfo')
    var user = localStorage.getItem('userInfo')
    user = JSON.parse(user)
    var openid = localStorage.getItem('openid')
    if (openid == null) {
      openid = user.openid
    }
    this.form.openid = openid
    this.form.uid = user.id
    this.getMoneyList()
  },
  computed: {
    getUserBalance() {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      return user.balance
    }
  },
  methods: {
    getMoneyList () {
      getShopChargeRulesList({}).then((res) => {
        if (res.success) {
          this.moneyList = res.data
        }
      })
    },
    // 获取用户信息
    submit() {
      if (!this.form.money) {
        this.$toast.fail('请选择充值金额')
        return;
      }
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      var openid = localStorage.getItem('openid')
      if (openid == null) {
        openid = user.openid
      }
      wxPayBalance(this.form).then((res) => {
        if (res.success) {
          const data = res.payMap
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              appId: data.appId, // 公众号名称(商户appid)
              timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
              nonceStr: data.nonceStr, // 随机串
              package: data.package,
              signType: data.signType, // 微信签名方式：
              paySign: data.paySign // 微信签名
            }, (r) => {
              console.log(r);
              if (r.err_msg == 'get_brand_wcpay_request:ok') {
                this.$toast.success('充值成功')
                this.$router.go(-1)
              }
            })
        }else{
          this.$toast.success('充值失败')
        }
      })
    },
    check(item) {
      this.form.money = item.money
      this.form.giveMoney = item.give
      this.form.chargeId = item.id
      this.active = item.money
    },
    detail() {
      this.$router.push('/detail')
    },
    go() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    .head{
      background-color: #F3F3F3;
      height:44px;
      line-height: 44px;
      opacity:1;
      display: flex;
      justify-content: space-between;
    }
    .content{
      padding: 12px;
      .rehint{
        padding: 22px;
        height:18px;
        font-size:13px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:18px;
        color:rgba(255,255,255,1);
        opacity:1;
      }
      .reprice{
        padding: 22px;
        height:40px;
        font-size:33px;
        font-family:DIN;
        font-weight:bold;
        line-height:40px;
        color:rgba(255,255,255,1);
        opacity:1;
      }
      .choose{
        height:20px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(51,51,51,1);
        margin-top: 25px;
      }
      .recharge{
        display: flex;
        flex-direction: row;
        /*justify-content : space-between;*/
        flex-wrap: wrap;
        .item{
          width:30%;
          padding: 10px;
          border-radius:5px;
          text-align: center;
          margin-top: 10px;
          margin-right: 0.6rem;
          font-size:1rem;
          font-family:SF Pro Display;
          font-weight:400;
          color:#000000;
          border:1px solid #FE003B;
          cursor: pointer;
          box-sizing: border-box;
        }
        .active{
          color: #FE003B;
          background:rgba(254,234,238,1);
        }
      }
      .money{
        margin-top: 20px;
        height: 40px;
        border-bottom: 1px solid #ebedf0;
      }
    }
  }
  .retype{
    display: flex;
    padding: 22px;
    .wechat{
      font-size:14px;
      font-family:PingFang SC;
      font-weight:bold;
      line-height:20px;
      color:rgba(51,51,51,1);
      margin-left: 10px;
      opacity:1;
    }
  }
  .submit{
    height:40px;
    width: 95%;
    background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
    opacity:1;
    border-radius:4px;
    color: #ffffff;
    margin: auto;
    text-align: center;
    line-height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/views/mine/mine_recharge.vue